<template>
  <section id="home_games_left">
    <div class="box">
      <p class="title is_clickable" @click="handleOpenGameInfoModal">
        <span>{{ authStore.user.availableGames }}</span>
        {{ $_translations.value.page_home_section_game_available_games }}
      </p>

      <BaseButton
        container-class="play"
        :disabled="!authStore.hasUserAvailableGames"
        @click:button="$emit('start:newGame')"
      >
        {{ $_translations.value.page_home_section_game_button_play }}
      </BaseButton>

      <BaseButton
        v-if="!appSettingsStore.isStoreDisabled"
        :disabled="authStore.hasUserAvailableGames"
        @click:button="$emit('redirect:storePage')"
      >
        {{ $_translations.value.page_home_section_game_button_store }}
      </BaseButton>
    </div>
  </section>

  <BalanceGameModal v-if="isBalanceGameModalOpen" />

  <ZeroBalanceGameModal
    v-else-if="isZeroBalanceGameModalOpen"
    @redirect:storePage="handleRedirectToStorePageFromZeroBalanceModal"
  />
</template>

<script setup>
import BaseButton from '@/components/button/BaseButton.vue';
import BalanceGameModal from '@/components/modal/game/BalanceGameModal.vue';
import ZeroBalanceGameModal from '@/components/modal/game/ZeroBalanceGameModal.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import useModalHook from '@/hooks/useModal.js';

const emits = defineEmits([
  'start:newGame',
  'redirect:storePage',
]);

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();

const [isBalanceGameModalOpen, openBalanceGameModal] = useModalHook();
const [isZeroBalanceGameModalOpen, openZeroBalanceGameModal, closeZeroBalanceGameModal] = useModalHook();

const handleOpenGameInfoModal = () => {
  if (authStore.hasUserAvailableGames) {
    openBalanceGameModal();
  } else {
    openZeroBalanceGameModal();
  }
};

const handleRedirectToStorePageFromZeroBalanceModal = async () => {
  await closeZeroBalanceGameModal({ immediate: true });

  emits('redirect:storePage');
};
</script>
